"use client";

import { useState } from "react";

export const useLocalStorage = <T>(
  key: string,
): {
  storedValue: T | null;
  setValue: (value: T) => T | null;
  removeValue: () => void;
} => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = localStorage.getItem(key);

      if (item) {
        return JSON.parse(item);
      }

      return null;
    } catch {
      return null;
    }
  });

  const setValue = (value: T): T | null => {
    try {
      const valueToStore = value;

      setStoredValue(valueToStore);
      localStorage.setItem(key, JSON.stringify(valueToStore));

      return valueToStore;
    } catch {
      return null;
    }
  };

  const removeValue = (): void => {
    try {
      localStorage.removeItem(key);
    } catch {
      return;
    }
  };

  return {
    storedValue,
    setValue,
    removeValue,
  };
};
